import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { MatrizConstatacoesService } from "../../../../../services/matriz-constatacao.service";
import { IAprovarMatrizPreliminarDto } from "../../../../../models/constatacao.model";
import { AuthService } from "../../../../../services/auth.service";


@Component({
  selector: 'app-modal-aprovar-matriz',
  templateUrl: './modal-aprovar-matriz-constatacao.component.html',
  styleUrls: ['./modal-aprovar-matriz-constatacao.component.scss']
})
export class ModalAprovarMatrizComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public id: number;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ModalAprovarMatrizComponent>,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matrizService: MatrizConstatacoesService
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      statusAvaliacao: [null, Validators.required], // number: 1 ou 2
      comentario: [null, [Validators.required, Validators.maxLength(200)]]
    });
  }

  public salvar(): void {
    if (!this.form.valid) {
      Swal.fire('Atenção', 'Preencha todos os campos obrigatórios', 'warning');
      return;
    }

    this.loading = true;

    const status = this.form.value.statusAvaliacao;

    const dto: IAprovarMatrizPreliminarDto = {
      id: this.data.matrizId,
      statusAvaliacao: status,
      comentarioAvaliacao: this.form.value.comentario,
      responsavelIdAvaliacao: this.authService.usuario.id
    };

    this.matrizService.aprovarMatrizPreliminar(dto)
      .then(res => {
        if (res.sucesso) {

          const mensagem =
            status === 2
              ? 'Matriz rejeitada com sucesso'
              : 'Matriz aprovada com sucesso';

          this.exibirSucesso(mensagem);
          this.dialogRef.close(true);

        } else {
          this.exibirErro('Não foi possível aprovar a matriz');
        }
      })
      .catch(() => {
        this.exibirErro('Não foi possível aprovar a matriz');
      })
      .finally(() => this.loading = false);
  }


  private exibirSucesso(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      text: mensagem,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    });
  }
  private exibirAviso(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'warning',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }

  public fechar(): void {
    this.dialogRef.close();
  }

  private exibirErro(mensagem: string): void {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'error',
      text: mensagem,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true
    });
  }
}
